import { gql } from '@apollo/client';

export const UPLOAD_FILE_MUTATION = gql`
  mutation uploadFile($input: UploadFileInput!) {
    uploadFile(input: $input) {
      fileId
      correlationId
    }
  }
`;

export const UPLOAD_DOCUMENT_MUTATION = gql`
  mutation uploadDocument($input: UploadDocumentInput!) {
    uploadDocument(input: $input) {
      correlationId
    }
  }
`;

export const UPDATE_DOCUMENT_DATA_MUTATION = gql`
  mutation updateDocumentData($input: UpdateDocumentDataInput!) {
    updateDocumentData(input: $input) {
      correlationId
    }
  }
`;

export const UPDATE_ADDED_DOCUMENT_DATA_MUTATION = gql`
  mutation updateAddedDocumentData($documentId: Int!, $siteId: Int!, $list: [AddedDocumentsListInput]!) {
    updateAddedDocumentData(documentId: $documentId, siteId: $siteId, list: $list) {
      correlationId
    }
  }
`;

export const UPLOAD_DOCUMENT_LIST_MUTATION = gql`
  mutation uploadDocumentList($input: UploadDocumentListInput!) {
    uploadDocumentList(input: $input) {
      correlationId
    }
  }
`;

export const AVAILABLE_UPLOAD_DOCUMENT_LIST_MUTATION = gql`
  mutation availableUploadDocumentList($documentId: Int!, $siteId: Int!) {
    availableUploadDocumentList(documentId: $documentId, siteId: $siteId) {
      correlationId
    }
  }
`;

export const CHANGE_DOCUMENT_ATTACHMENT_STATE_MUTATION = gql`
  mutation changeDocumentAttachmentState($input: DocumentAttachmentStateInput!) {
    changeDocumentAttachmentState(input: $input) {
      correlationId
    }
  }
`;

export const CHANGE_BULK_DOCUMENT_ATTACHMENT_STATE_MUTATION = gql`
  mutation bulkChangeDocumentAttachmentState($input: BulkDocumentAttachmentsStateInput!) {
    bulkChangeDocumentAttachmentState(input: $input) {
      correlationId
    }
  }
`;

export const GENERATE_ATTACHMENTS_AND_PRINTS_MUTATION = gql`
  mutation generateAttachmentAndPrints($input: GenerateAttachmentAndPrintsInput!) {
    generateAttachmentAndPrints(input: $input) {
      correlationId
    }
  }
`;

export const DELETE_DOCUMENT_ATTACHMENT_MUTATION = gql`
  mutation deleteDocumentAttachment($input: DeleteDocumentAttachmentInput!) {
    deleteDocumentAttachment(input: $input) {
      correlationId
    }
  }
`;

export const DELETE_DOCUMENT_ATTACHMENT_FILES_MUTATION = gql`
  mutation deleteDocumentAttachmentFiles($input: DeleteDocumentAttachmentFilesInput!) {
    deleteDocumentAttachmentFiles(input: $input) {
      correlationId
    }
  }
`;

export const SIGN_DOCUMENTS_MUTATION = gql`
  mutation signDocuments($documentId: Int!, $siteId: Int!, $files: [SignDocumentsFiles]!) {
    signDocuments(documentId: $documentId, siteId: $siteId, files: $files) {
      correlationId
    }
  }
`;

export const CANCEL_DOCUMENT_SIGN_MUTATION = gql`
  mutation cancelDocumentSign($documentId: Int!, $siteId: Int!, $documentPrintId: Int!) {
    cancelDocumentSign(documentId: $documentId, siteId: $siteId, documentPrintId: $documentPrintId) {
      correlationId
    }
  }
`;

export const EXPORT_DOCUMENT_MUTATION = gql`
  mutation exportDocument($documentId: Int!, $siteId: Int!, $documentPrintId: Int!) {
    exportDocument(documentId: $documentId, siteId: $siteId, documentPrintId: $documentPrintId) {
      correlationId
    }
  }
`;

export const EXPORT_SIMULATION_MUTATION = gql`
  mutation exportSimulation($documentId: Int!, $siteId: Int!, $simulationId: Int!) {
    exportSimulation(documentId: $documentId, siteId: $siteId, simulationId: $simulationId) {
      correlationId
    }
  }
`;

export const PRINT_DOCUMENTS_MUTATION = gql`
  mutation printDocuments(
    $documentId: Int!
    $siteId: Int!
    $selectedDocuments: [SelectedDocuments]!
    $sendEmail: Boolean!
    $defaultEmail: String
  ) {
    printDocuments(
      documentId: $documentId
      siteId: $siteId
      selectedDocuments: $selectedDocuments
      sendEmail: $sendEmail
      defaultEmail: $defaultEmail
    ) {
      correlationId
    }
  }
`;

export const LOAD_EXPORT_DOCUMENT_LIST_MUTATION = gql`
  mutation getExportDocumentList($input: ExportDocumentListInput!) {
    getExportDocumentList(input: $input) {
      correlationId
    }
  }
`;

export const SAVE_BULK_DOCUMENT_MUTATION = gql`
  mutation bulkUploadDocument($input: BulkUploadDocumentInput!) {
    bulkUploadDocument(input: $input) {
      correlationId
    }
  }
`;

export const DELETE_BUFFER_TEMP_FILES = gql`
  mutation deleteBufferTempFiles($documentId: Int!, $siteId: Int!) {
    deleteBufferTempFiles(documentId: $documentId, siteId: $siteId)
  }
`;

export const ALL_UPLOAD_DOCUMENT_LIST_MUTATION = gql`
  mutation allUploadDocumentList($documentId: Int!, $siteId: Int!) {
    allUploadDocumentList(documentId: $documentId, siteId: $siteId) {
      correlationId
    }
  }
`;
